import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

interface FinalCTASectionProps {
  onExploreClick: () => void;
}

export function FinalCTASection({ onExploreClick }: FinalCTASectionProps) {
  const { t } = useLanguage();

  return (
    <section className="bg-background py-14 sm:py-20 border-t border-border">
      <div className="max-w-2xl mx-auto px-4 text-center space-y-6">
        <h2 className="text-xl sm:text-2xl font-bold text-foreground tracking-tight">
          {t("landing.finalCta.headline")}
        </h2>
        
        <p className="text-muted-foreground text-sm sm:text-base max-w-md mx-auto">
          {t("landing.finalCta.subheadline")}
        </p>

        <Button
          size="lg"
          onClick={onExploreClick}
          className="min-h-[52px] px-10 text-base rounded-sm"
        >
          {t("landing.finalCta.button")}
        </Button>

        <p className="text-xs text-muted-foreground">
          {t("landing.finalCta.disclaimer")}
        </p>
      </div>
    </section>
  );
}
